import { useMemo } from 'react';
import { LocalizationConfig } from './localization';
import { useGetRegionsQuery } from '../regions/regionsApi';
import { useUserInfo, useUserPreference } from '../user/userApi';
import { useCan } from '../user/Can';
import { LANGUAGE_LOCALES } from './languages';

export const DefaultLocale = LANGUAGE_LOCALES.EN_AU;

const DefaultConfig = () => {
  try {
    return LocalizationConfig[/-(\w+)/g.exec(DefaultLocale)[1]] || LocalizationConfig.AU;
  } catch (error) {
    return LocalizationConfig.AU;
  }
};

export function useLocalizationConfig() {
  const data = useUserInfo();
  const { data: regions } = useGetRegionsQuery(undefined, { skip: data.id === undefined });
  const userPref = useUserPreference();
  const can = useCan();

  const localization = useMemo(() => {
    try {
      return mergedRegionConfig(userPref?.language, regions, userPref, can);
    } catch (error) {}
    return DefaultConfig();
  }, [regions, userPref]);

  return localization;
}

const mergedRegionConfig = (userPrefLocale = DefaultLocale, regions = [], userPref, can) => {
  const regionCode =
    (/-(\w+)/g.exec(userPrefLocale) &&
      /-(\w+)/g.exec(userPrefLocale)[1] &&
      /-(\w+)/g.exec(userPrefLocale)[1].toUpperCase()) ||
    /-(\w+)/g.exec(DefaultLocale)[1]; //AU/CA/US.etc
  const staticConfig = LocalizationConfig[regionCode] || DefaultConfig();
  const region = regions?.find(region => region?.code === regionCode);

  let regionConfig = Object.assign({}, region || {});
  try {
    regionConfig.config = JSON.parse(regionConfig.config);
  } catch (error) {
    regionConfig.config = {};
  }
  try {
    regionConfig.states = JSON.parse(regionConfig.states);
  } catch (error) {
    regionConfig.states = {};
  }
  try {
    regionConfig.timezone = JSON.parse(regionConfig.timezone);
  } catch (error) {
    regionConfig.timezone = {};
  }

  return {
    ...staticConfig,
    ...{
      country: regionConfig.name || staticConfig.country,
      locale: userPrefLocale || staticConfig.locale,
      default_time_zone: regionConfig.config.default_time_zone || staticConfig.default_time_zone,
      support_email: regionConfig.supportEmail || staticConfig.support_email,
      support_doc_link: regionConfig.config.help_center || staticConfig.support_doc_link,
      timezone: regionConfig.timezone || {},
      states: regionConfig.states || {},
      code: regionConfig.code
    },
    time: {
      ...staticConfig,
      formats: staticConfig.time['formats' + (userPref.timeFormat ?? '12H')]
    },
    supportCustomTimeFormat: true,
    timeFormat: userPref.timeFormat ?? '12H'
  };
};
